import React, { useEffect } from "react";
import QuillEditor from "../../../../components/QuillEditor/QuillEditor";
import styles from "../../Introspekcije.module.css";
import Navigation from "./Navigation";
function PolaznikView({
  initialRoute,
  title,
  firstIds,
  introspectionId,
  setDisabledPrevious,
  lastIds,
  setDisabledNext,
  disabledPrevious,
  disabledNext,
  programId,
  introspectionNumber,
  isDone,
  handleUpdate,
  setIsModalOpen,
  mentorData,
  introspectionData,
  handleNotify,
  answers,
  setUserAnswer,
  userId,
  setIsMaxCharCount,
  setIsDone,
  setIsLoading,
  isMentorRole,
  isMaxCharCount,
  isNoCharCount,
  setIsNoCharCount,
  setIsEditorDirty,
  quillRef,
  isEditorDirty,
}) {
  useEffect(() => {
    if (firstIds.includes(introspectionId)) {
      setDisabledPrevious(true);
    } else if (lastIds.includes(introspectionId)) {
      setDisabledNext(true);
    } else {
      setDisabledPrevious(false);
      setDisabledNext(false);
    }
  }, [
    introspectionId,
    firstIds,
    lastIds,
    setDisabledNext,
    setDisabledPrevious,
  ]);
  const questions = introspectionData?.questions ?? "";

  return (
    <div className={styles.polaznikWrapper}>
      <Navigation
        initialRoute={initialRoute}
        title={title}
        disabledPrevious={disabledPrevious}
        introspectionId={introspectionId}
        programId={programId}
        introspectionNumber={introspectionNumber}
        disabledNext={disabledNext}
      />
      <QuillEditor
        answer={introspectionData?.userInIntrospection?.userAnswer}
        introspectionQuestions={questions}
        setUserAnswer={setUserAnswer}
        userId={userId}
        isReadOnly={false}
        setIsMaxCharCount={setIsMaxCharCount}
        setIsDone={setIsDone}
        isMentorRole={isMentorRole}
        setIsLoading={setIsLoading}
        setIsNoCharCount={setIsNoCharCount}
        isNoCharCount={isNoCharCount}
        isContainerShowed={
          (isMentorRole && answers.length > 0) || !isMentorRole
        }
        isMaxCharCount={isMaxCharCount}
        setIsEditorDirty={setIsEditorDirty}
        ref={quillRef}
        isEditorDirty={isEditorDirty}
      />
      <div className={styles.btnWrapper}>
        <button
          className={styles.saveBtn}
          onClick={async () => {
            await handleUpdate();
            setTimeout(() => {
              setIsModalOpen(true);
            }, 1000);
          }}
          disabled={isNoCharCount || isMaxCharCount}
        >
          Spremi introspekciju
        </button>
        {mentorData &&
          introspectionData?.userInIntrospection?.isNotifyAllowed && (
            <button
              className={styles.saveBtn}
              onClick={async () => {
                try {
                  await handleNotify();
                  await handleUpdate();
                } catch (error) {
                  console.error("Error saving before notify:", error);
                }
              }}
              disabled={
                !isDone ||
                !introspectionData?.userInIntrospection?.isNotifyAllowed ||
                isNoCharCount
              }
            >
              Obavijesti mentora
            </button>
          )}
      </div>
    </div>
  );
}

export default PolaznikView;
